jQuery(document).ready(function ($) {
  // const bestellenItems = [
  //   {
  //     title: "Spuit-naaldcombinatie 3ml",
  //     description: "Minimale afname 1 doos á 100 stuks (max 50)",
  //   },
  //   {
  //     title: "Injectienaalden 0,5mmx16mm",
  //     description: "Minimale afname 1 doos á 100 stuks (max 40)",
  //   },
  //   {
  //     title: "Softa Swabs",
  //     description: "Minimale afname 1 overdoos á 10x100 stuks (max 10)",
  //   },
  //   {
  //     title: "Ascorbinezuur",
  //     description: "Minimale afname 1 zak á 100 potjes (max 5)",
  //   },
  //   {
  //     title: "Filters",
  //     description: "Minimale afname 1 overdoos á 10x100 stuks (max 10)",
  //   },
  //   {
  //     title: "Stericups",
  //     description: "Minimale afname 1 zak á 50 stuks (max 10)",
  //   },
  //   {
  //     title: "Condooms (Glyder Ambassador)",
  //     description: "Minimale afname 1 doos á 144 stuks (max 10)",
  //   },
  //   {
  //     title: "Glijmiddel (Beppy Action Jelly)",
  //     description: "Minimale afname 1 doos á 50 stuks (max 10)",
  //   },
  //   { title: "Minicontainer 0,25l", description: "Minimaal 1 stuks (max 100)" },
  //   {
  //     title: "Container 4L (septobox)",
  //     description: "Minimale afname 1 stuks (max 20)",
  //   },
  //   {
  //     title: "Container 25L (septobox)",
  //     description: "Minimale afname 1 stuks (max 5)",
  //   },
  //   {
  //     title: "Container 50L (septobox)",
  //     description: "Minimale afname 1 stuks (max 5)",
  //   },
  // ];

  // const terugsturenItems = [
  //   {
  //     title: "Container 25L (septobox)",
  //     description: "Minimale afname 1 stuks (max 5)",
  //   },
  //   {
  //     title: "Injectienaalden 0,5mmx16mm",
  //     description: "Container 50L (septobox)",
  //   },
  // ];

  $(".email-row").hide();

  const orderForm = $("#OrderForm");

  const checkboxInput = $("#checkboxForm");
  const emailInput = $("#email");
  const responseSuccessElement = $("#responseSuccess");

  const stepWrapper = $(".steps-wrapper .tab");
  const tabWrapper = $(".tabs-wrapper .tab");
  let currentStep = 0;
  const totalSteps = stepWrapper.length;

  function updateEmailRowVisibility() {
    const isChecked = checkboxInput.is(":checked");
    const emailVal = emailInput.val().trim();

    if (isChecked && !emailVal) {
      $(".email-row").show();
      emailInput.removeClass("bg-rdmGray").prop("disabled", false);
    } else if (!isChecked && emailVal) {
      $(".email-row").show();
      emailInput.addClass("bg-rdmGray").prop("disabled", true);
    } else if (!isChecked && !emailVal) {
      $(".email-row").hide();
      emailInput.removeClass("bg-rdmGray").prop("disabled", false);
    } else {
      $(".email-row").show();
      emailInput.removeClass("bg-rdmGray").prop("disabled", false);
    }
  }

  // // Run once on load
  if (checkboxInput.length) {
    updateEmailRowVisibility();
  }

  // Bind to events
  checkboxInput.on("change", updateEmailRowVisibility);
  emailInput.on("input", updateEmailRowVisibility);

  // On checkbox change
  checkboxInput.on("change", updateEmailRowVisibility);

  // On email input change
  emailInput.on("input", updateEmailRowVisibility);

  // Save values to sessionStorage on change
  $("#note").on("input", function () {
    sessionStorage.setItem("note", $(this).val());
  });

  $("#checkboxForm").on("change", function () {
    sessionStorage.setItem("checkboxForm", this.checked);
  });

  // Load stored values on page load
  if (sessionStorage.getItem("note")) {
    $("#note").val(sessionStorage.getItem("note"));
  }

  if (sessionStorage.getItem("checkboxForm") === "true") {
    $("#checkboxForm").prop("checked", true).trigger("change");
  }

  function renderCards(items, containerSelector) {
    $(containerSelector).empty();
    items.forEach((item) => {
      const imageHtml = item.image
        ? `<img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover" />`
        : `<div class="bg-rdmGray w-full h-full"></div>`;

      const html = `
        <div class="qty-card bg-white p-4 mb-4 border border-rdmGray04 flex flex-wrap gap-4 md:gap-5 justify-between items-center relative" data-title="${item.title}" data-des="${item.description}" data-qty="">
          <div class="image-container w-full md:w-[109px] aspect-[1.35:1] overflow-hidden">
          ${imageHtml}
          </div>
          <div class="item-details mr-auto">
            <h3 class="text-rdmGreen font-bold">${item.title}</h3>
            <p class="mb-0">${item.description}</p>
          </div>
          <div class="qty-wrapper flex gap-2 justify-end items-stretch">
            <span class="self-center pr-2">Aantal</span>
            <button class="minus aspect-square w-[48px] bg-black text-white">-</button>
            <input type="number" min="0" class="form-control text-center border border-rdmGray08 max-w-[60px]" name="quantity" value="0">
            <button class="plus aspect-square w-[48px] bg-black text-white">+</button>
          </div>
        </div>
      `;
      $(containerSelector).append(html);
    });
  }

  if (typeof bestellenItems !== "undefined" && bestellenItems.length) {
    renderCards(bestellenItems, "#bestellenWrapper");
  }
  if (typeof terugsturenItems !== "undefined" && terugsturenItems.length) {
    renderCards(terugsturenItems, "#terugsturenWrapper");
  }

  function updateButtonText() {
    $("#next-step").text(
      currentStep === totalSteps - 1 ? "Bestelling plaatsen" : "Volgende"
    );
  }

  function updateStepsTabs() {
    stepWrapper.removeClass("done active");
    stepWrapper.each(function (index) {
      if (index < currentStep) $(this).addClass("done");
      if (index === currentStep) $(this).addClass("active");
    });

    $(".step-content").removeClass("active");
    $("#" + stepWrapper.eq(currentStep).data("tab")).addClass("active");
    updateTabLabelsForMobile();
  }

  function updateTabLabelsForMobile() {
    // Reset all labels and classes
    stepWrapper.each(function () {
      const originalText = $(this).data("tab");
      $(this)
        .removeClass("prev-arrow-left next-arrow-right")
        .text(originalText)
        .show();
    });

    if (window.innerWidth > 768) return;

    // Mobile-specific arrow logic
    if (currentStep === 0) {
      stepWrapper.eq(1).addClass("next-arrow-right").text("").show();
      stepWrapper.eq(2).hide();
    } else if (currentStep === 1) {
      stepWrapper.eq(0).addClass("prev-arrow-left").text("").show();
      stepWrapper.eq(2).addClass("next-arrow-right").text("").show();
    } else if (currentStep === 2) {
      stepWrapper.eq(0).hide();
      stepWrapper.eq(1).addClass("prev-arrow-left").text("").show();
      // Remove arrow from tab 2
      stepWrapper.eq(2).removeClass("next-arrow-right");
    }
  }

  function validateQuantities() {
    const $overviewTab = $('li[data-tab="Overzicht"]');

    // Only validate on Step 2
    if (currentStep === 1) {
      const allInputs = $(
        '#bestellenWrapper input[name="quantity"], #terugsturenWrapper input[name="quantity"]'
      );

      const hasValidQuantity = allInputs.toArray().some((input) => {
        const val = parseInt($(input).val(), 10);
        return !isNaN(val) && val > 0;
      });

      $("#next-step").prop("disabled", !hasValidQuantity);
      // Disable button & hide "Overzicht" tab only if no valid quantity
      if (window.innerWidth < 768) {
        $overviewTab.toggleClass("!hidden", !hasValidQuantity);
      }
    } else {
      $("#next-step").prop("disabled", false);
      // $overviewTab.removeClass("!hidden");
    }
  }

  $(document).on("click", ".tabs-wrapper .tab", function () {
    tabWrapper.removeClass("active");
    $(this).addClass("active");
    $(".tab-content").removeClass("active");
    $("#" + $(this).data("tab")).addClass("active");
  });

  $(document).on("click", ".qty-card .plus, .qty-card .minus", function () {
    const $card = $(this).closest(".qty-card");
    const $input = $card.find('input[name="quantity"]');
    let qty = parseInt($input.val(), 10) || 0;

    if ($(this).hasClass("plus")) qty += 1;
    else if ($(this).hasClass("minus") && qty > 0) qty -= 1;

    $input.val(qty);
    $card.attr("data-qty", qty);

    validateQuantities();
  });

  $(document).on("click", "#loggedOut , .logout", function (e) {
    e.preventDefault();
    sessionStorage.clear();
    window.location.href =
      "https://www.ggdrotterdamrijnmond.nl/spuitomruil#materialen-bestellen";
  });

  function getBestellenDataFromInputs(containerSelector) {
    const items = [];
    $(`${containerSelector} .qty-card`).each(function () {
      const title = $(this).data("title");
      const description = $(this).data("des");
      const qty =
        parseInt($(this).find('input[name="quantity"]').val(), 10) || 0;
      const image = $(this).find(".image-container img").attr("src") || "";
      if (qty > 0) {
        items.push({ title, description, qty, image });
      }
    });
    return items;
  }

  function renderOverzichtTable() {
    const BestellenData = JSON.parse(
      sessionStorage.getItem("BestellenData") || "[]"
    );
    const TerugsturenData = JSON.parse(
      sessionStorage.getItem("TerugsturenData") || "[]"
    );

    const renderTable = (title, data) => {
      if (!data.length) return "";

      const rows = data
        .map((item) => {
          const imageHtml = item.image
            ? `<img src="${item.image}" alt="${item.title}" class="w-full h-full object-cover" />`
            : `<div class="bg-rdmGray w-full h-full test"></div>`;

          return `
            <tr>
              <td>
                <div class="image-container w-full md:w-[109px] aspect-[1.35:1] overflow-hidden">
                  ${imageHtml}
                </div>
              </td>
              <td class="text-rdmGreen font-bold">${item.title}</td>
              <td class="text-right">${item.qty ?? 0}</td>
            </tr>
          `;
        })
        .join("");

      return `
        <table class="mb-4">
          <thead class="border-b border-rdmGray04">
            <tr>
              <th colspan="2" class="h5">${title}</th>
              <th class="text-right text-rdmGray11 font-normal">Aantal</th>
            </tr>
          </thead>
          <tbody>${rows}</tbody>
        </table>
      `;
    };

    const orderTable = renderTable("Bestellingen", BestellenData);
    const returnTable = renderTable("Terugsturen", TerugsturenData);

    // Only show content if at least one table has data
    if (orderTable || returnTable) {
      $("#overzichtWrapper").html(`${orderTable}${returnTable}`);
    } else {
      $("#overzichtWrapper").empty(); // Clear the wrapper if nothing to show
    }
  }

  function applyStoredQuantitiesToCards(storedItems, containerSelector) {
    storedItems.forEach((item) => {
      const $card = $(
        `${containerSelector} .qty-card[data-title="${item.title}"][data-des="${item.description}"]`
      );
      if ($card.length) {
        $card.attr("data-qty", item.qty);
        $card.find('input[name="quantity"]').val(item.qty);
      }
    });
  }

  function validateFormFields(fields) {
    const errors = {};
    if (!fields.email || !/\S+@\S+\.\S+/.test(fields.email)) {
      errors.email = "A valid email is required.";
    }
    return errors;
  }

  $("#prev-step").hide();

  $(document).on("click", "#next-step, .next-arrow-right", function (e) {
    if (currentStep === 0) {
      const BestellenData = getBestellenDataFromInputs("#bestellenWrapper");
      sessionStorage.setItem("BestellenData", JSON.stringify(BestellenData));
      validateQuantities();
    } else if (currentStep === 1) {
      const TerugsturenData = getBestellenDataFromInputs("#terugsturenWrapper");
      sessionStorage.setItem(
        "TerugsturenData",
        JSON.stringify(TerugsturenData)
      );
    } else if (currentStep === 2) {
      const email = $("#email").val().trim();
      const isChecked = $("#checkboxForm").is(":checked");
      const errors = isChecked ? validateFormFields({ email }) : {};

      if (errors.email) {
        $(".email-row").addClass("alert");
        $(".email-row .error").text(errors.email);
        e.preventDefault();
        e.stopPropagation();
        return;
      } else {
        $(".email-row").removeClass("alert");
        $(".email-row .error").text("");
        sessionStorage.setItem("email", email);

        if (orderForm.length) {
          const payload = {
            // organisation info from sessionStorage here:
            organisation_id: sessionStorage.getItem("OrganisationID"),
            organisation_name: sessionStorage.getItem("OrganisationName"),
            organisation_password: sessionStorage.getItem(
              "OrganisationPassword"
            ),
            organisation_email: sessionStorage.getItem("OrganisationEmail"),

            e_mail_adres: sessionStorage.getItem("email") || "",
            email_mij_een_kopie_van_dit_overzicht:
              sessionStorage.getItem("checkboxForm") || false,
            opmerkingen: sessionStorage.getItem("note") || "",
            bestellen: JSON.parse(
              sessionStorage.getItem("BestellenData") || "[]"
            ).map((item) => ({
              item: item.title,
              quantity: item.qty,
            })),
            terugsturen: JSON.parse(
              sessionStorage.getItem("TerugsturenData") || "[]"
            ).map((item) => ({
              item: item.title,
              quantity: item.qty,
            })),
          };

          $.ajax({
            url: "/api/form/order_form/submit",
            type: "POST",
            data: JSON.stringify(payload),
            contentType: "application/json",
            success: function (response) {
              console.log("response", response);
              responseSuccessElement.html("");

              sessionStorage.setItem("orderComplete", "true");

              $("#startOrder").hide();
              $("#doneOrder").show();

              resetForm();
            },
            error: function (error) {
              console.error("error", error);
              try {
                const response = JSON.parse(error.responseText);
                console.log("Parsed error response", response);
              } catch (e) {
                console.log("Error parsing responseText", error.responseText);
              }
            },
          });
        }
      }
    }

    if (currentStep < totalSteps - 1) {
      currentStep++;

      // Update layout based on currentStep
      if (currentStep === 0) {
        $(".step-button-wrapper")
          .addClass("justify-end")
          .removeClass("justify-between");
      } else {
        $(".step-button-wrapper")
          .addClass("justify-between")
          .removeClass("justify-end");
      }

      $("#prev-step").toggle(currentStep > 0);
      updateStepsTabs();
      updateButtonText();
      renderOverzichtTable();
      validateQuantities();
    }
  });

  $(document).on("click", "#prev-step, .prev-arrow-left", function () {
    if (currentStep > 0) {
      currentStep--;
      updateStepsTabs();
      updateButtonText();
    }
    if (currentStep === 0) {
      $("#prev-step").hide();
      $(".step-button-wrapper")
        .addClass("justify-end")
        .removeClass("justify-between");
    }
  });

  function resetForm() {
    currentStep = 0;

    // Clear all text inputs and textareas
    orderForm.find('input[type="text"], textarea').val("");

    // Uncheck checkboxes
    orderForm.find('input[type="checkbox"]').prop("checked", false);

    // Optionally clear your dynamic tables too
    sessionStorage.removeItem("BestellenData");
    sessionStorage.removeItem("TerugsturenData");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("checkboxForm");
    sessionStorage.removeItem("note");

    $("#bestellenWrapper").empty();
    $("#terugsturenWrapper").empty();
    $("#overzichtWrapper").empty();

    stepWrapper.removeClass("done active");
    stepWrapper.eq(currentStep).addClass("active");

    $(".step-content").removeClass("active");
    $("#" + stepWrapper.eq(currentStep).data("tab")).addClass("active");

    renderCards(bestellenItems, "#bestellenWrapper");

    updateTabLabelsForMobile();
  }

  // Load stored quantities
  const BestellenData = JSON.parse(
    sessionStorage.getItem("BestellenData") || "[]"
  );
  const TerugsturenData = JSON.parse(
    sessionStorage.getItem("TerugsturenData") || "[]"
  );
  applyStoredQuantitiesToCards(BestellenData, "#bestellenWrapper");
  applyStoredQuantitiesToCards(TerugsturenData, "#terugsturenWrapper");
  renderOverzichtTable();

  updateStepsTabs();
  updateButtonText();
  updateTabLabelsForMobile();
  validateQuantities();

  if (sessionStorage.getItem("orderComplete") === "true") {
    $("#startOrder").hide();
    $("#doneOrder").show();
  } else {
    $("#startOrder").show();
    $("#doneOrder").hide();
  }

  if (sessionStorage.getItem("OrganisationPassword")) {
    $(".logout").show();
  } else {
    $(".logout").hide();
  }

  $(window).on("resize", updateTabLabelsForMobile);
});
